<script setup lang="ts">
import SignUp from "./signUp/SignUp.vue";
import SignIn from "./signIn/SignIn.vue";
import ForgotPassword from "./forgotPassword/ForgotPassword.vue";

const route = useRoute()
const {openModal} = useModal();

onMounted(() => {
  if (route.query?.login) {
    openModal('sign-modal')
  }
})
</script>

<template>
  <Modal id="sign-modal" :style="{ maxWidth: '550px' }">
    <SignIn/>
  </Modal>
  <Modal id="signup-modal" :style="{ maxWidth: '550px' }">
    <SignUp/>
  </Modal>
  <Modal id="forgot-password-modal" :style="{ maxWidth: '550px' }">
    <ForgotPassword/>
  </Modal>
</template>
<style>
#sign-modal,
#signup-modal {
  width: 100%
}
</style>
